import { render, staticRenderFns } from "./BInformation.vue?vue&type=template&id=69413af2"
import script from "./BInformation.vue?vue&type=script&lang=js"
export * from "./BInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports